import { render, staticRenderFns } from "./FollowCreateForm.vue?vue&type=template&id=4cb7958e&scoped=true"
import script from "./FollowCreateForm.vue?vue&type=script&lang=js"
export * from "./FollowCreateForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cb7958e",
  null
  
)

export default component.exports